import { APP_VERSION, formatAppVersionLabel } from '../lib/appVersion';
import { tokens } from '../design-system/tokens';

type Props = {
  /** Texto sobre fondo oscuro (sidebar, docs header). */
  onDark?: boolean;
  title?: string;
};

/** Etiqueta compacta de versión para pie de sidebar o documentación. */
export function AppVersionLabel({ onDark = false, title }: Props) {
  const label = formatAppVersionLabel();
  return (
    <span
      title={title ?? `Virtual Agents ${label}`}
      style={{
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.04em',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        color: onDark ? tokens.semantic.textOnDarkMuted : tokens.semantic.textMuted,
        opacity: 0.9,
      }}
    >
      {label}
    </span>
  );
}

export { APP_VERSION };
